import { LitState, stateVar } from 'lit-element-state';
import { apiGet } from 'chipta-libs/api/utils.js';


class EventsState extends LitState {

  constructor() {
    super();
    this.events = stateVar(_ticketshopData.events);
  }

}

const eventsState = new EventsState();

export default eventsState;

export function filterOnLocation(lat, lon, rangeKm) {
  apiGet(
    `ticketshop-events-overview/${_ticketshopData.id}/` +
    `?lat=${lat}&lon=${lon}&range_km=${rangeKm}`
  ).then(response => {
    eventsState.events = response.data.events;
  });
}
